import React, { useEffect, useRef } from 'react';

// Canvas-based animated film grain, 12fps — port of the live theme's main.js.
function GrainCanvas() {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) {
            return undefined;
        }

        const ctx = canvas.getContext('2d');
        let width = 0;
        let height = 0;
        let animId = null;

        const resize = () => {
            width = canvas.width = window.innerWidth;
            height = canvas.height = window.innerHeight;
        };

        const generateNoise = () => {
            if (!width || !height) {
                return;
            }
            const imageData = ctx.createImageData(width, height);
            const buf = new Uint32Array(imageData.data.buffer);
            const len = buf.length;

            for (let i = 0; i < len; i += 1) {
                const v = (Math.random() * 255) | 0;
                // ABGR format (canvas is little-endian)
                buf[i] = (255 << 24) | (v << 16) | (v << 8) | v;
            }

            ctx.putImageData(imageData, 0, 0);
        };

        let lastFrame = 0;
        const FPS = 12;
        const INTERVAL = 1000 / FPS;

        const loop = (ts) => {
            animId = requestAnimationFrame(loop);
            if (ts - lastFrame < INTERVAL) {
                return;
            }
            lastFrame = ts;
            generateNoise();
        };

        resize();
        window.addEventListener('resize', resize, { passive: true });
        animId = requestAnimationFrame(loop);

        return () => {
            window.removeEventListener('resize', resize);
            if (animId) {
                cancelAnimationFrame(animId);
            }
        };
    }, []);

    return <canvas id="grain-canvas" ref={canvasRef} aria-hidden="true" />;
}

export default GrainCanvas;
